module.exports = __webpack_public_path__ + "static/media/solution-selection-large.f2c4d16e.png";